import React, { useState } from 'react';
import { ShieldIcon, XIcon } from 'lucide-react';
function LegalModal({
  isOpen,
  onClose,
  title,
  content
}: any) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm" data-id="element-51">
      <div className="relative w-full max-w-2xl max-h-[90vh] overflow-auto bg-slate-900 border border-slate-700 rounded-xl shadow-2xl" data-id="element-52">
        <div className="sticky top-0 bg-slate-900 border-b border-slate-800 p-4 flex justify-between items-center z-10" data-id="element-53">
          <h2 className="text-xl font-bold text-white" data-id="element-54">{title}</h2>
          <button onClick={onClose} className="p-1 rounded-full hover:bg-slate-800 text-slate-400 hover:text-white transition-colors" data-id="element-55">
            <XIcon className="h-6 w-6" data-id="element-56" />
          </button>
        </div>
        <div className="p-6 text-slate-300 text-sm leading-relaxed" data-id="element-57">
          {content}
        </div>
      </div>
    </div>;
}
export function Footer() {
  const [activeModal, setActiveModal] = useState<string | null>(null);
  return <footer className="bg-slate-950 border-t border-slate-900 py-12" data-id="element-58">
      <div className="max-w-7xl mx-auto px-5 md:px-8 text-center" data-id="element-59">
        <div className="flex items-center justify-center gap-2 text-white font-bold text-xl tracking-wide mb-4 opacity-50" data-id="element-60">
          <ShieldIcon className="h-6 w-6" data-id="element-61" />
          <span data-id="element-62">EL CÓDIGO</span>
        </div>
        <p className="text-sm text-slate-500 mb-6" data-id="element-63">
          © {new Date().getFullYear()} Todos los derechos reservados.
        </p>

        <div className="flex justify-center space-x-6 text-sm text-slate-400" data-id="element-64">
          <button onClick={() => setActiveModal('terms')} className="hover:text-brand-400 transition-colors" data-id="element-65">
            Términos y Condiciones
          </button>
          <button onClick={() => setActiveModal('privacy')} className="hover:text-brand-400 transition-colors" data-id="element-66">
            Política de Privacidad
          </button>
        </div>
      </div>

      <LegalModal isOpen={activeModal !== null} onClose={() => setActiveModal(null)} title={activeModal === 'terms' ? 'Términos y Condiciones' : 'Política de Privacidad'} content={<div className="space-y-4" data-id="element-68">
            <p data-id="element-69">
              Este producto no garantiza resultados específicos. Las técnicas
              enseñadas son de carácter educativo y táctico. Al adquirir "El
              Código de Micro-Señales", aceptas utilizarlo bajo tu propia
              responsabilidad.
            </p>
            <p data-id="element-70">
              Este sitio no es parte del sitio web de Facebook o Facebook Inc.
              Además, este sitio NO está respaldado por Facebook de ninguna
              manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
            </p>
          </div>} data-id="element-67" />
    </footer>;
}